import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastActions } from "../ToastSlice/toast-slice";
import { v4 as uuidv4 } from "uuid";

export const getAllCollections = createAsyncThunk(
  "collections/getAllCollections",
  async (arg, { rejectWithValue }) => {
    const url = process.env.REACT_APP_DB_COLLECTION_URL + "/collections";
    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      return rejectWithValue("Couldn't get collections");
    }
    const data = await response.json();
    return { collections: data.message };
  }
);

export const createNewCollection = createAsyncThunk(
  "collections/createNewCollection",
  async (details, { rejectWithValue, dispatch }) => {
    const { name, description } = details;
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "INFO",
        message: `Creating collection ${name}`,
      })
    );
    const url = process.env.REACT_APP_DB_COLLECTION_URL + "/collections";

    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name, description }),
    });
    if (!response.ok) {
      dispatch(
        toastActions.addToast({
          id: uuidv4(),
          type: "DANGER",
          message: `Couldn't create collection ${name}`,
        })
      );
      return rejectWithValue("Couldn't create collection");
    }
    const data = await response.json();
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "SUCCESS",
        message: `Created collection ${name}`,
      })
    );
    return { collections: data.collections };
  }
);

export const getOneCollection = createAsyncThunk(
  "collections/getOneCollection",
  async (collectionId, { rejectWithValue }) => {
    const { id } = collectionId;
    const url = process.env.REACT_APP_DB_COLLECTION_URL + `/collections/${id}`;
    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      return rejectWithValue("Couldn't get collection details");
    }
    const data = await response.json();
    console.log("data", data);
    return { collections: data.collections };
  }
);

export const addToCollection = createAsyncThunk(
  "collections/addToCollection",
  async (imageInfo, { rejectWithValue, dispatch }) => {
    const { collectionId, id, url, username, name, link, colName } = imageInfo;
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "INFO",
        message: `Adding image to ${colName}`,
      })
    );
    const beUrl =
      process.env.REACT_APP_DB_COLLECTION_URL + `/collections/${collectionId}`;
    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(beUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id, url, username, name, link }),
    });
    if (!response.ok) {
      dispatch(
        toastActions.addToast({
          id: uuidv4(),
          type: "DANGER",
          message: `Couldn't add image to ${colName}`,
        })
      );
      return rejectWithValue("Couldn't add to liked images");
    }
    const data = await response.json();
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "SUCCESS",
        message: `Added image to ${colName}`,
      })
    );
    return { collections: data.collections };
  }
);

export const removeFromCollection = createAsyncThunk(
  "collections/removeFromCollection",
  async (imageInfo, { rejectWithValue, dispatch }) => {
    const { id, imageId, colName } = imageInfo;
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "INFO",
        message: `Removing image from ${colName}`,
      })
    );
    const url = process.env.REACT_APP_DB_COLLECTION_URL + `/collections/${id}`;
    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ imageId: imageId }),
    });
    if (!response.ok) {
      dispatch(
        toastActions.addToast({
          id: uuidv4(),
          type: "DANGER",
          message: `Couldn't remove image from ${colName}`,
        })
      );
      return rejectWithValue("Couldn't remove liked image");
    }
    const data = await response.json();
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "SUCCESS",
        message: `Removed image from ${colName}`,
      })
    );
    return { collections: data.collections };
  }
);

export const deleteOneCollection = createAsyncThunk(
  "collections/deleteOneCollection",
  async (imageInfo, { rejectWithValue, dispatch }) => {
    const { id, name } = imageInfo;
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "INFO",
        message: `Deleting collection ${name}`,
      })
    );
    const url = process.env.REACT_APP_DB_COLLECTION_URL + `/collections/${id}`;
    const token = localStorage.getItem("authTokenPIXELBAY");
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id }),
    });
    if (!response.ok) {
      dispatch(
        toastActions.addToast({
          id: uuidv4(),
          type: "DANGER",
          message: `Couldn't delete collection ${name}`,
        })
      );
      return rejectWithValue("Couldn't remove liked image");
    }
    const data = await response.json();
    dispatch(
      toastActions.addToast({
        id: uuidv4(),
        type: "SUCCESS",
        message: `Deleted collection ${name}`,
      })
    );
    return { collections: data.collections };
  }
);
